import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d214720e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "html-content" }
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = ["innerHTML"]

import { ExtendedProductInformationLayouts } from '@/types/extendedProductInformation';
import ContentImage from "./ContentImage.vue";
import ContentImageText from "./ContentImageText.vue";
import ContentDownloads from "./ContentDownloads.vue";
import ContentFeaturedLinks from "./ContentFeaturedLinks.vue";

interface Props {
	content: ExtendedProductInformationLayouts;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'HtmlContent',
  props: {
    content: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.content, (item, index) => {
      return (_openBlock(), _createElementBlock(_Fragment, null, [
        (item.acf_fc_layout === 'title')
          ? (_openBlock(), _createElementBlock("h2", {
              key: index + 'title',
              innerHTML: item.title,
              class: "html-content__title"
            }, null, 8, _hoisted_2))
          : (item.acf_fc_layout === 'text')
            ? (_openBlock(), _createElementBlock("div", {
                key: index + 'text',
                innerHTML: item.text,
                class: "html-content__text"
              }, null, 8, _hoisted_3))
            : (item.acf_fc_layout === 'image')
              ? (_openBlock(), _createBlock(ContentImage, {
                  key: index + 'image',
                  image: item.image,
                  "image-size": "medium_large"
                }, null, 8, ["image"]))
              : (item.acf_fc_layout === 'image-text')
                ? (_openBlock(), _createBlock(ContentImageText, {
                    key: index + 'image-text',
                    image: item.image,
                    title: item.title,
                    text: item.text
                  }, null, 8, ["image", "title", "text"]))
                : (item.acf_fc_layout === 'downloads')
                  ? (_openBlock(), _createBlock(ContentDownloads, {
                      key: index + 'downloads',
                      title: item.title,
                      downloads: item.downloads
                    }, null, 8, ["title", "downloads"]))
                  : (item.acf_fc_layout === 'featured-links')
                    ? (_openBlock(), _createBlock(ContentFeaturedLinks, {
                        key: index + 'featured-links',
                        title: item.title,
                        "featured-links": item.featured_links_repeater
                      }, null, 8, ["title", "featured-links"]))
                    : _createCommentVNode("", true)
      ], 64))
    }), 256))
  ]))
}
}

})